import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../../button/back";

const DownloadJurnal = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sekolah, setSekolah] = useState([]);
  const [datakepsek, setDataKepsek] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [namaPengawas, setNamaPengawas] = useState("");
  const [nipPengawas, setNipPengawas] = useState("");

  const tableRef = useRef(null);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/jurnal-kepsek`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setData(res.data);
      } catch {
        alert("Gagal mengambil data jurnal");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  /* ================= DATA SEKOLAH ================= */
  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/datasekolah/all`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setSekolah(res.data || []);
      } catch {
        alert("Gagal mengambil data sekolah");
      }
    };
    fetchSchoolData();
  }, []);

  /* ================= KEPSEK ================= */
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}api/auth/user-images-and-roles`)
      .then((res) =>
        setDataKepsek(res.data.filter((u) => u.jabatan === "Kepala Sekolah"))
      )
      .catch(() => alert("Gagal mengambil data kepala sekolah"));
  }, []);
  const getTanggalIndonesia = () => {
    const now = new Date();

    const bulan = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return `${now.getDate()} ${bulan[now.getMonth()]} ${now.getFullYear()}`;
  };
  // Fungsi format tanggal Indonesia dari string
  const formatTanggalIndonesia = (tanggalStr) => {
    const t = new Date(tanggalStr);
    const bulan = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    return `${t.getDate()} ${bulan[t.getMonth()]} ${t.getFullYear()}`;
  };

  /* ================= FILTER TANGGAL ================= */
  const filteredData = useMemo(() => {
    if (!startDate || !endDate) return [];
    return data
      .filter(
        (d) =>
          new Date(d.tanggal) >= new Date(startDate) &&
          new Date(d.tanggal) <= new Date(endDate)
      )
      .sort((a, b) => new Date(a.tanggal) - new Date(b.tanggal));
  }, [data, startDate, endDate]);

  /* ================= DOWNLOAD PDF ================= */
  const handleDownloadPDF = async () => {
    if (!filteredData.length) return alert("Tidak ada data untuk diunduh!");

    const input = tableRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("l", "pt", "a4");
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth() - 40; // margin kiri & kanan
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 20, 20, pdfWidth, pdfHeight);

    pdf.save(`Laporan_Jurnal_${startDate}_sampai_${endDate}.pdf`);
  };

  if (loading) return <p className="p-4">Loading...</p>;

  return (
    <div className="p-4 max-w-7xl mx-auto bg-white">
      <h1 className="text-xl font-semibold mb-4">
        Download Jurnal Kepala Sekolah
      </h1>

      {/* ================= FILTER TANGGAL ================= */}
      <div className="flex flex-wrap gap-4 mb-6">
        <div>
          <label className="text-sm block mb-1">Dari Tanggal</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border rounded px-3 py-2"
          />
        </div>
        <div>
          <label className="text-sm block mb-1">Sampai Tanggal</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border rounded px-3 py-2"
          />
        </div>
      </div>

      {/* ================= INPUT PENGAWAS ================= */}
      <div className="flex flex-wrap gap-4 mb-6">
        <div>
          <label className="text-sm block mb-1">Nama Pengawas</label>
          <input
            type="text"
            value={namaPengawas}
            onChange={(e) => setNamaPengawas(e.target.value)}
            className="border rounded px-3 py-2"
          />
        </div>
        <div>
          <label className="text-sm block mb-1">NIP Pengawas</label>
          <input
            type="text"
            value={nipPengawas}
            onChange={(e) => setNipPengawas(e.target.value)}
            className="border rounded px-3 py-2"
          />
        </div>
      </div>

      {/* ================= BUTTON DOWNLOAD ================= */}
      <button
        onClick={handleDownloadPDF}
        className="bg-blue-600 text-white px-4 py-2 rounded mb-6 hover:bg-blue-700 transition"
      >
        Download PDF
      </button>

      {/* ================= TABEL ================= */}
      {startDate && endDate && (
        <div className="overflow-x-auto  p-2" ref={tableRef}>
          <h2 className="text-center font-semibold mb-4">
            Laporan Kegiatan Kepala Sekolah {sekolah[0]?.namasekolah || ""}
          </h2>
          <div className=" p-4 text-sm ">
            <div className="grid grid-cols-[200px_1fr] gap-x-2 gap-y-1">
              <span className="font-semibold">Nama Sekolah</span>
              <span>: {sekolah[0]?.namasekolah || "-"}</span>

              <span className="font-semibold">Nama Kepala Sekolah</span>
              <span>: {datakepsek[0]?.name || "-"}</span>

              <span className="font-semibold">Periode</span>
              <span>
                :{formatTanggalIndonesia(startDate)} s/d{" "}
                {formatTanggalIndonesia(endDate)}
              </span>
            </div>
          </div>

          <table className="w-full border border-black text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-black px-2 pb-2 w-[50px]">No</th>
                <th className="border border-black px-2 pb-2 w-[120px]">
                  Tanggal
                </th>
                <th className="border border-black px-2 pb-2">Judul</th>
                <th className="border border-black px-2 pb-2">Tujuan</th>
                <th className="border border-black px-2 pb-2">Kegiatan</th>
                <th className="border border-black px-2 pb-2">Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    className="border border-black text-center py-4"
                  >
                    Data tidak ditemukan
                  </td>
                </tr>
              ) : (
                filteredData.map((jurnal, index) =>
                  jurnal.jurnal.map((item, i) => (
                    <tr key={`${jurnal._id}-${i}`}>
                      {i === 0 && (
                        <td
                          rowSpan={jurnal.jurnal.length}
                          className="border border-black px-2 pb-2 text-center align-top"
                        >
                          {index + 1}
                        </td>
                      )}
                      {i === 0 && (
                        <td
                          rowSpan={jurnal.jurnal.length}
                          className="border border-black px-2 pb-2 align-top"
                        >
                          {new Date(jurnal.tanggal).toLocaleDateString("id-ID")}
                        </td>
                      )}
                      <td className="border border-black px-2 pb-2">
                        {item.judul}
                      </td>
                      <td className="border border-black px-2 pb-2">
                        {item.tujuan}
                      </td>
                      <td className="border border-black px-2 pb-2">
                        {item.kegiatan}
                      </td>
                      <td className="border border-black px-2 py-2">
                        {item.keterangan}
                      </td>
                    </tr>
                  ))
                )
              )}
            </tbody>
          </table>
          <div className="mt-6 flex justify-between px-4 text-sm">
            <div>
              <br />
              <p>Mengetahui</p>
              <p>Pengawas</p>
              <br />
              <br />
              <br />
              <div className="absolute  border-b border-black pb-1">
                <p> {namaPengawas}</p>
              </div>
              <br />
              <p>NIP.{nipPengawas}</p>
            </div>
            <div className="mr-20">
              <p>
                {sekolah[0]?.ttDsekolah || ""}, {getTanggalIndonesia()}
              </p>
              <br />
              <p>Kepala Sekolah</p>
              <br />
              <br />
              <br />

              <div className="absolute  border-b border-black pb-1">
                <p> {datakepsek[0]?.name || ""}</p>
              </div>
              <br />
              <p>NIP.{datakepsek[0]?.NIP}</p>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center">
        <Link to={`/profile/${id}`}>
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default DownloadJurnal;
